import { timeChipClickHandler } from '../TimeFilters/helpers'

/**
 * Determine whether a Dynamic Filter (DF) Chip is selected or not.
 *
 * @param {String} type: STOPS, AIRLINES, etc.
 * @param {Array} stopsFilter, airlinesFilter, etc: Current applied filters form state
 * @returns True/False
 */
const getSelected = ({
  type,
  filterId,
  stopsFilter,
  airlinesFilter,
  airportsFilter,
  attributesFilter,
  timebands,
}) => {
  const isFilterChecked = ({ value, checked }) => filterId === value && checked

  const isArray = (array) => Array.isArray(array)

  if (type === 'STOPS' && isArray(stopsFilter)) {
    return stopsFilter?.find(isFilterChecked)
  }

  if (type === 'AIRLINES' && isArray(airlinesFilter)) {
    return airlinesFilter?.find(isFilterChecked)
  }

  // Dynamic Filters use TAKEOFF_AIRPORT and LANDING_AIRPORT, Recommended Filters use AIRPORT
  if (
    (type === 'AIRPORT' || type === 'TAKEOFF_AIRPORT' || type === 'LANDING_AIRPORT') &&
    isArray(airportsFilter)
  ) {
    const { originAirports, destinationAirports } = airportsFilter?.[0]
    return [originAirports, destinationAirports].some((airports) => airports?.find(isFilterChecked))
  }

  if (type === 'TAKEOFF_TIME') {
    return timebands?.takeoff?.includes(filterId)
  } else if (type === 'LANDING_TIME') {
    return timebands?.landing?.includes(filterId)
  }

  if (type === 'ATTRIBUTES') {
    return attributesFilter?.find(isFilterChecked)
  }

  return false
}

/**
 * Performs Filter API Call when a DF chip is selected/de-selected
 *
 * @param {*} selected state and click handlers
 */
const updateFilters = ({
  isSelectedFromState,
  type,
  filterId,
  handleStopsChange,
  handleAirlineChange,
  handleTimeChipClick,
  handleAttributeChange,
  airportsFilter,
  activeTabId = 1,
  timebands,
}) => {
  const isSelected = isSelectedFromState
  switch (type) {
    case 'STOPS':
      const stopKeyChange = { [filterId]: !isSelected }
      handleStopsChange(stopKeyChange)
      break
    // Dynamic Filters use TAKEOFF_AIRPORT and LANDING_AIRPORT, Recommended Filters use AIRPORT
    case 'AIRPORT':
    case 'TAKEOFF_AIRPORT':
    case 'LANDING_AIRPORT':
      airportsFilter.handleChange({ [filterId]: !isSelected })
      break
    case 'AIRLINES':
      handleAirlineChange({ [filterId]: !isSelected })
      break
    case 'TAKEOFF_TIME':
      timeChipClickHandler({
        disable: false, // This needs to be updated to the actual
        activeTimes: timebands,
        entity: 'takeoff',
        label: filterId,
        handleTimeChipClick,
        sliceRefId: activeTabId,
      })
      break
    case 'LANDING_TIME':
      timeChipClickHandler({
        disable: false, // This needs to be updated to the actual
        activeTimes: timebands,
        entity: 'landing',
        label: filterId,
        handleTimeChipClick,
        sliceRefId: activeTabId,
      })
      break
    case 'ATTRIBUTES':
      handleAttributeChange({ [filterId]: !isSelected })
      break
    default:
      return
  }
}

export { getSelected, updateFilters }
